<template>
  <el-container>
    <el-form ref="ruleForm" :model="ruleForm" label-width="90px" :rules="rules">
      <el-form-item label="设备编号" prop="device_code">
        <el-input v-model="ruleForm.device_code" maxlength="128" show-word-limit disabled />
      </el-form-item>
      <el-form-item label="设备名称" prop="device_name">
        <el-input v-model="ruleForm.device_name" maxlength="20" show-word-limit />
      </el-form-item>
      <el-form-item label="所属客户" prop="owner_org_id">
        <el-select v-model="ruleForm.owner_org_id" placeholder="选择所属客户" disabled>
          <el-option
            v-for="item in ownerOrgList"
            :key="item.value"
            :label="item.text"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="设备类型" prop="device_type_id">
        <el-select v-model="ruleForm.device_type_id" placeholder="选择设备类型" disabled>
          <el-option
            v-for="item in share.deviceTypeList"
            :key="item.value"
            :label="item.text"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="设备型号" prop="device_model_id" ref="ruleForm_device_model">
        <el-select v-model="ruleForm.device_model_id" placeholder="选择设备型号" disabled>
          <el-option
            v-for="item in share.deviceModelList"
            :key="item.value"
            :label="item.text"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="合作模式" prop="device_purpose">
        <el-select v-model="ruleForm.device_purpose" placeholder="选择合作模式">
          <el-option
            v-for="item in devicePurpose"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="供应商" prop="supply_org_id">
        <el-select v-model="ruleForm.supply_org_id" placeholder="选择供应商">
          <el-option
            v-for="item in supplyOrgList"
            :key="item.value"
            :label="item.text"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="安装地址" prop="install_address">
        <el-input v-model="ruleForm.install_address" maxlength="50" show-word-limit />
      </el-form-item>
      <el-form-item label="安装时间" prop="install_time">
        <el-date-picker
          v-model="ruleForm.install_time"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="联系人" prop="contact_name">
        <el-input v-model="ruleForm.contact_name" />
      </el-form-item>
      <el-form-item label="联系电话" prop="contact_mobile">
        <el-input v-model="ruleForm.contact_mobile" />
      </el-form-item>
      <el-form-item label="设备类别" prop="is_virtual">
        <el-checkbox v-model="ruleForm.is_virtual" disabled>机器</el-checkbox>
      </el-form-item>
      <el-form-item label="启用设备" prop="is_enable">
        <el-checkbox v-model="ruleForm.is_enable">是</el-checkbox>
      </el-form-item>
      <el-form-item>
        <el-button class="btn_dialog" @click="$emit('tableCloseDialog')">取消</el-button>
        <el-button class="btn_dialog cz" @click="resetForm">重置</el-button>
        <el-button class="btn_dialog qd" @click="confirm">确认</el-button>
      </el-form-item>
    </el-form>
  </el-container>
</template>

<script>
import BasicDataHelper from '@/api/basic_data_helper'
import Backend from '@/api/backend'

export default {
  name: '',
  data () {
    return {
      service: 'device',
      id_name: 'device_id',
      devicePurpose: BasicDataHelper.devicePurpose,
      ruleForm: {
        device_id: '',
        device_code: '',
        device_name: '',
        device_type_id: '',
        device_model_id: '',
        owner_org_id: '',
        device_purpose: '',
        supply_org_id: '',
        install_time: '',
        install_address: '',
        contact_name: '',
        contact_mobile: '',
        is_virtual: false,
        is_enable: ''
      },
      rules: {
        device_code: [
          { required: true, message: '请输入设备编号', trigger: 'blur' }
        ],
        device_name: [
          { required: true, message: '请输入设备名称', trigger: 'blur' }
        ],
        owner_org_id: [
          { required: true, message: '请选择所属客户', trigger: 'change' }
        ],
        device_type_id: [
          { required: true, message: '请选择设备类型', trigger: 'change' }
        ],
        device_model_id: [
          { required: true, message: '请选择设备型号', trigger: 'change' }
        ],
        device_purpose: [
          { required: true, message: '请选择合作模式', trigger: 'change' }
        ],
        supply_org_id: [
          { required: true, message: '请选择供应商', trigger: 'change' }
        ],
        contact_mobile: [
          {
            pattern: /(^([0-9]{3,4}-)?[0-9]{7,8}$)|(^(0|86|17951)?1[3-9][0-9]{9}$)/,
            message: '请输入有效的电话号码'
          }
        ]
      },
      share: {
        deviceTypeList: [],
        deviceModelList: []
      }
    }
  },

  props: {
    rowData: {
      default: () => {},
      type: Object
    },
    ownerOrgList: {
      default: () => [],
      type: Array
    },
    supplyOrgList: {
      default: () => [],
      type: Array
    }
  },

  created () {
    this.getDeviceTypeList()
    this.getRow(this.rowData)
  },

  methods: {
    getDeviceTypeList () {
      Backend.get(this, '/device_type/cmd/list/key_field/device_type_name/value_field/device_type_id/max_results/100/text/', 0).then(data => {
        this.share.deviceTypeList = data.items
      })
    },
    getDeviceModelList (id) {
      Backend.get(this, `/device_model/cmd/list/key_field/device_model_name/value_field/device_model_id/max_results/100/device_type_id/${id}/text/`, 0).then(data => {
        this.share.deviceModelList = data.items
      })
    },
    getRow (data) {
      for (const k in this.ruleForm) {
        this.$set(this.ruleForm, k, data[k])
      }
      this.getDeviceModelList(this.ruleForm.device_type_id)
    },
    resetForm () {
      this.$refs.ruleForm.resetFields()
    },
    confirm () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const params = {}

          for (const k in this.ruleForm) {
            params[k] = this.ruleForm[k]
          }
          params.install_time = params.install_time || '1970-01-01'

          Backend.editRow(this, params, undefined, '设备')
        }
      })
    }
  }
}
</script>
